import { config as baseConfig } from '../config';

const { debug: isDebug } = baseConfig;

// window[config.APP_NAME].module.register("console.me", require('../extras/console-me.js'));

export const event = isDebug ? console.log : () => '';
export const debug = isDebug ? console.log : () => '';
export const hook = isDebug ? console.log : () => '';

window.event = event;
window.debug = debug;
window.hook = hook;

export default {
  event,
  debug,
  hook,
};
